class ProductSample extends HTMLElement {
  constructor() {
    super();

    this.SCROLL_DELAY = 425;

    this.trigger = document.querySelector(".js-sample-scroll-trigger");
    this.addToBags = this.querySelectorAll('.js-sample-trigger');
    this.cart = document.querySelector('cart-drawer');
    this.addAllToBags = this.querySelector('.js-samples-trigger');

    this.addToBags.forEach(addToBag => addToBag.addEventListener("click", () => this.addProduct(addToBag)));
    this.addAllToBags.addEventListener("click", () => this.addProducts());
    this.trigger.addEventListener("click", this.scrollToSample.bind(this));

    this.syncWithCart();

    let t;
    if (this.cart) new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => this.syncWithCart(), 300); })
      .observe(this.cart, { childList: true, subtree: true });
  }

  syncWithCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(({ items }) => {
        const ids = items.map(i => String(i.variant_id));
        const samples = this.querySelectorAll('.js-sample');
        let allInCart = samples.length > 0;
        samples.forEach(sample => {
          const inCart = ids.includes(String(sample.dataset.id));
          sample.querySelector('.js-sample-trigger').toggleAttribute('disabled', inCart);
          if (!inCart) allInCart = false;
        });
        this.addAllToBags.toggleAttribute('disabled', allInCart);
      });
  }

  addProduct(button) {
    const sample = button.closest('.js-sample');
    const object = [this.createProductObj(sample)];
    const spinner = button.querySelector('.loading-overlay__spinner');

    this.addToBag(button, object, spinner);
  }

  addProducts() {
    const samples = this.querySelectorAll('.js-sample');
    const objects = Array.from(samples).map(sample => this.createProductObj(sample));
    const button = this.addAllToBags;
    const spinner = button.querySelector('.loading-overlay__spinner');

    this.addToBag(button, objects, spinner);
  }

  addToBag(button, samples, spinner) {
    button.setAttribute("disabled", "true");
    button.classList.add("loading");

    spinner.classList.remove("hidden");

    const cart = document.querySelector('cart-drawer');
    const payload = { items: samples };

    if (cart) {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    const config = fetchConfig('javascript');
    config.headers['Content-Type'] = 'application/json';
    config.body = JSON.stringify(payload);

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then(response => {
        if (response.status) throw new Error(response.description || response.message);
        if (cart) cart.renderContents(response);
      })
      .then(() => {
        this.syncWithCart();

        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      })
      .catch((error) => {
        console.error("Error:", error);
        button.removeAttribute("disabled");
      })
      .finally(() => {
        button.classList.remove("loading");
        spinner.classList.add("hidden");
      });
  }

  createProductObj(sample) {
    return {
      id: sample.dataset.id,
      quantity: 1,
      properties: {
        ...((sample.dataset?.barcode != null) && {
          _barcode: sample.dataset.barcode,
        }),
      },
    };
  }

  scrollToSample(event) {
    event.preventDefault();

    const targetId = this.trigger.getAttribute("href");
    const targetElement = document.querySelector(targetId);

    if (!targetElement) return;

    this.openAccordion(targetElement);

    setTimeout(() => {
      const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      const header = document.querySelector(".header");
      const headerHeight = header ? header.offsetHeight : 0;
      const offset = targetPosition - headerHeight;
      const scrollOptions = {
        top: offset,
        behavior: "smooth",
      }

      window.scrollTo(scrollOptions);
    }, this.SCROLL_DELAY);
  }

  openAccordion(accordion) {
    const accordionItem = accordion.closest('.accordion__item');

    if (!accordionItem.classList.contains('accordion__item--open')) {
      accordion.click();
    }
  }
}

if (!customElements.get("product-samples")) {
  customElements.define("product-samples", ProductSample);
}
